"use strict";

export function init() {
    const eventSticky = document.querySelector('.event-nav');

    if (eventSticky) {
        const navLinks = Array.from(document.querySelectorAll('.event-nav__link'));

        const sections = document.querySelectorAll('[data-nav-title]');
        const sectionsFilter = Array.from(sections).filter(section => section.id);

        const actions = eventSticky.querySelector('.event-nav__actions');

        const measureActions = function() {
            const previousWidth = actions.style.width;
            const previousTransition = actions.style.transition;

            actions.style.transition = 'none';
            actions.style.width = 'auto';

            const width = actions.getBoundingClientRect().width;

            actions.style.width = previousWidth;
            actions.style.transition = previousTransition;

            if (!width) return;

            const value = Math.ceil(width) + 'px';

            if (eventSticky.style.getPropertyValue('--event-nav-actions-width') !== value) {
                eventSticky.style.setProperty('--event-nav-actions-width', value);
            }
        };

        if (actions) {
            measureActions();

            if (window.ResizeObserver) {
                const actionsObserver = new ResizeObserver(measureActions);

                const observeChildren = () => {
                    actionsObserver.disconnect();
                    Array.from(actions.children).forEach(child => actionsObserver.observe(child));
                };

                observeChildren();

                new MutationObserver(() => {
                    observeChildren();
                    measureActions();
                }).observe(actions, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
            }

            window.addEventListener('resize', measureActions);
        }

        const updateCtaVisibility = function() {
            const eventHeader = document.querySelector('.event-header');
            const rect = eventHeader ? eventHeader.getBoundingClientRect() : null;

            if (rect && rect.bottom <= window.innerHeight / 2) {
                eventSticky.classList.add('show-cta');
            } else {
                eventSticky.classList.remove('show-cta');
            }
        };

        window.addEventListener('scroll', updateCtaVisibility, { passive: true });

        updateCtaVisibility();

        document.addEventListener('click', function(e){
            const link = e.target;

            if (link.classList.contains('event-nav__link')){
                const id = link.getAttribute('href').slice(1);
                const block = document.getElementById(id);

                if (block) {
                    e.preventDefault();
                    block.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });


        if (window.location.hash) {
            const targetElement = document.getElementById(window.location.hash.slice(1));
            if (targetElement != null) {
                const globalHeader = document.querySelector('.global-header');
                const stickyNavHeight = globalHeader ? globalHeader.offsetHeight : 0;


                let targetPosition;

                if (document.querySelector('.event-nav__nav')) {
                    const eventNavHeight = document.querySelector('.event-nav__nav').offsetHeight;
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - eventNavHeight;
                } else if (document.querySelector('.global-alerts')) {
                    const globalBannerHeight = document.querySelector('.global-alerts').offsetHeight;
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - globalBannerHeight;
                } else {
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight;
                }

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }

        const getSwiper = () => document.querySelector('.event-nav__nav')?.swiper;

        const translateSwiperTo = (swiper, translate) => {
            const clamped = Math.min(
                Math.max(translate, swiper.maxTranslate()),
                swiper.minTranslate()
            );

            if (Math.abs(swiper.translate - clamped) > 1) {
                swiper.translateTo(clamped, 300, false, true);
            }
        };

        const centreLink = target => {
            const swiper = getSwiper();
            const slideEl = target.closest('.swiper-slide');

            if (swiper && slideEl) {
                const slides = Array.from(swiper.slides);
                const index = slides.indexOf(slideEl);

                if (index === -1) return;

                if (swiper.slidesGrid?.length && swiper.slidesSizesGrid?.length) {
                    const offset = swiper.slidesGrid[index]
                                 - (swiper.width - swiper.slidesSizesGrid[index]) / 2;

                    translateSwiperTo(swiper, -offset);
                    swiper.updateActiveIndex(index);
                    swiper.updateSlidesClasses();
                } else {
                    swiper.slideTo(index);
                }

                return;
            }

            const scroller = eventSticky.querySelector('.event-nav__nav');

            if (scroller && getComputedStyle(scroller).overflowX !== 'hidden') {
                const targetRect = target.getBoundingClientRect();
                const scrollerRect = scroller.getBoundingClientRect();
                const delta = (targetRect.left + targetRect.width / 2)
                            - (scrollerRect.left + scrollerRect.width / 2);

                if (Math.abs(delta) > 1) {
                    scroller.scrollBy({
                        left: delta,
                        behavior: 'smooth'
                    });
                }
            }
        };

        const setActiveLink = target => {
            navLinks.forEach(link => link.classList.remove('active'));
            target.classList.add('active');

            centreLink(target);
        };

        if (navLinks.length) {
            navLinks.forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();

                    const href = link.getAttribute('href') || '';
                    const targetId = href.split('#')[1];
                    const targetElement = document.getElementById(targetId);
                    if (!targetElement) return;

                    const headerScroll = document.querySelector('.header-scroll');
                    const eventStickyNav = document.querySelector('.event-nav__nav');

                    const stickyNavHeight = headerScroll ? headerScroll.offsetHeight : 0;
                    const eventNavHeight = eventStickyNav ? eventStickyNav.offsetHeight : 0;

                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - eventNavHeight;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });

                    setActiveLink(link);
                });
            });
        }

        const resetScrollPosition = () => {
            const swiper = getSwiper();

            if (swiper) {
                translateSwiperTo(swiper, swiper.minTranslate());
                swiper.updateActiveIndex(0);
                swiper.updateSlidesClasses();
                return;
            }

            const scroller = eventSticky.querySelector('.event-nav__nav');

            if (scroller && scroller.scrollLeft > 1) {
                scroller.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
            }
        };

        const updateActiveLinkOnScroll = () => {
            let currentSection = '';
            const viewportMiddle = window.scrollY + window.innerHeight / 2;
            const firstSection = sectionsFilter[0];

            sectionsFilter.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionBottom = sectionTop + section.offsetHeight;

                if (viewportMiddle >= sectionTop && viewportMiddle < sectionBottom) {
                    currentSection = section.getAttribute('id');
                }
            });

            if (firstSection && viewportMiddle < firstSection.offsetTop) {
                resetScrollPosition();
            }

            if (currentSection) {
                const activeLink = navLinks.find(link => {
                    const href = link.getAttribute('href') || '';
                    const id = href.includes('#') ? href.split('#')[1] : null;
                    return id === currentSection;
                });

                if (activeLink && !activeLink.classList.contains('active')) {
                    setActiveLink(activeLink);
                }
            } else {
                navLinks.forEach(link => link.classList.remove('active'));
            }
        };

        window.addEventListener('scroll', updateActiveLinkOnScroll);
        window.addEventListener('resize', () => {
            updateActiveLinkOnScroll();
        });

        updateActiveLinkOnScroll();
    }
}
